export default "__VITE_PUBLIC_ASSET__5eaa8d75__"